import { Controller } from "@hotwired/stimulus";
import { flip, computePosition, offset } from "@floating-ui/dom";

// Connects to data-controller="tooltip"
export default class extends Controller {
  static values = {
    content: String,
    placement: { type: String, default: "left" },
  };

  async connect() {
    this.popoverAnchor = document.getElementById(
      this.element.dataset.popoverAnchorId,
    );
    if (!this.popoverAnchor) {
      console.error(
        "Popover anchor not found",
        this.element.dataset.popoverAnchorId,
      );
      return;
    }
    this.boundHide = () => this.hide();
    this.element.addEventListener("click", this.boundHide);
    this.showTimeout = setTimeout(() => this.show(), 250);
    this.hideTimeout = setTimeout(() => this.hide(), 5000);
    return;
  }

  disconnect() {
    this.element.removeEventListener("click", this.boundHide);
    if (this.showTimeout) {
      clearTimeout(this.showTimeout);
    }
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
  }

  show() {
    computePosition(this.popoverAnchor, this.element, {
      placement: "right-start",
      middleware: [offset(5), flip()],
    }).then(({ x, y, placement, middlewareData }) => {
      Object.assign(this.element.style, {
        left: `${x}px`,
        top: `${y}px`,
      });
    });
    this.element.setAttribute("aria-hidden", "false");
    this.popoverAnchor.setAttribute(
      "aria-describedby",
      this.element.getAttribute("id"),
    );
  }

  hide() {
    this.element.setAttribute("aria-hidden", "true");
    this.popoverAnchor.removeAttribute("aria-describedby");
  }
}
